import React, { useState } from 'react';
import { LayoutDashboard, Users, Building, FileText, Download, Calendar, BarChart3, PieChart } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { MessageModal } from '../../components/modals/MessageModal';
export function ReportsPage() {
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState('Last 30 Days');
  const handleDateRangeChange = () => {
    setIsMessageModalOpen(true);
  };
  const handleExportPDF = () => {
    setIsMessageModalOpen(true);
  };
  const navItems = [{
    label: 'Overview',
    icon: LayoutDashboard,
    path: '/dashboard/developer'
  }, {
    label: 'Inventory',
    icon: Building,
    path: '/developer/inventory'
  }, {
    label: 'Leads & CRM',
    icon: Users,
    path: '/developer/leads'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/developer/reports'
  }];
  return <DashboardLayout title="Developer Console" personaLabel="DEVELOPER" personaColor="bg-blue-100 text-blue-800 border-blue-200" navItems={navItems} userInitials="DL" data-id="element-3967">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-3968">
        <h1 className="text-2xl font-bold" data-id="element-3969">Analytics & Reports</h1>
        <div className="flex gap-2" data-id="element-3970">
          <button onClick={handleDateRangeChange} className="flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50" data-id="element-3971">
            <Calendar className="w-4 h-4" data-id="element-3972" /> {dateRange}
          </button>
          <button onClick={handleExportPDF} className="flex items-center gap-2 px-3 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3973">
            <Download className="w-4 h-4" data-id="element-3974" /> Export PDF
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-3975">
        <div className="bg-white border border-gray-300 p-6" data-id="element-3976">
          <h3 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-3977">
            <BarChart3 className="w-5 h-5" data-id="element-3978" /> Sales Performance
          </h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center" data-id="element-3979">
            <span className="text-gray-400 font-mono" data-id="element-3980">[Revenue Bar Chart]</span>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-6 text-center" data-id="element-3981">
            <div data-id="element-3982">
              <div className="text-xs text-gray-500 uppercase" data-id="element-3983">Revenue</div>
              <div className="font-bold text-lg" data-id="element-3984">₹ 4.2 Cr</div>
            </div>
            <div data-id="element-3985">
              <div className="text-xs text-gray-500 uppercase" data-id="element-3986">Units Sold</div>
              <div className="font-bold text-lg" data-id="element-3987">8</div>
            </div>
            <div data-id="element-3988">
              <div className="text-xs text-gray-500 uppercase" data-id="element-3989">Avg Price</div>
              <div className="font-bold text-lg" data-id="element-3990">₹ 52.5 L</div>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-6" data-id="element-3991">
          <h3 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-3992">
            <PieChart className="w-5 h-5" data-id="element-3993" /> Lead Sources
          </h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center" data-id="element-3994">
            <span className="text-gray-400 font-mono" data-id="element-3995">[Source Pie Chart]</span>
          </div>
          <div className="mt-6 space-y-2" data-id="element-3996">
            <div className="flex justify-between text-sm" data-id="element-3997">
              <span data-id="element-3998">Direct Website</span>
              <span className="font-bold" data-id="element-3999">45%</span>
            </div>
            <div className="flex justify-between text-sm" data-id="element-4000">
              <span data-id="element-4001">Social Media</span>
              <span className="font-bold" data-id="element-4002">30%</span>
            </div>
            <div className="flex justify-between text-sm" data-id="element-4003">
              <span data-id="element-4004">Referrals</span>
              <span className="font-bold" data-id="element-4005">25%</span>
            </div>
          </div>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={dateRange === 'Last 30 Days' ? 'Change Date Range' : 'Export Report'} message={dateRange === 'Last 30 Days' ? 'Date range selector coming soon. You will be able to select custom date ranges, compare periods, and view historical trends.' : 'Generating comprehensive PDF report... In production, this would download a detailed analytics report with charts, tables, and insights.'} type="info" data-id="element-4006" />
    </DashboardLayout>;
}